export const POST_SAVED_VIDEO_REQUEST = "POST_SAVED_VIDEO_REQUEST";
export const POST_SAVED_VIDEO_SUCCESS = "POST_SAVED_VIDEO_SUCCESS";
export const POST_SAVED_VIDEO_ERROR = "POST_SAVED_VIDEO_ERROR";

export const GET_SAVED_VIDEO_REQUEST = "GET_SAVED_VIDEO_REQUEST";
export const GET_SAVED_VIDEO_SUCCESS = "GET_SAVED_VIDEO_SUCCESS";
export const GET_SAVED_VIDEO_ERROR = "GET_SAVED_VIDEO_ERROR";

export const DEL_SAVED_VIDEO_REQUEST="DEL_SAVED_VIDEO_REQUEST";
export const DEL_SAVED_VIDEO_SUCCESS="DEL_SAVED_VIDEO_SUCCESS";
export const DEL_SAVED_VIDEO_ERROR="DEL_SAVED_VIDEO_ERROR";
